<template>
	<v-container fluid class="pb-2">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat outlined class="pb-0 pt-0">
					<v-card-text class="pb-0 pt-2">
						<v-row>
							<v-col class="pb-0 pt-0">
								<v-card-title class="d-flex justify-left align-center pa-2 pb-0">
									{{ $t('titles.stats') }}</v-card-title
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pt-0">
								<TheTable
									:additional-filters="surveyStatsTable.additionalFilters"
									:default-sort="surveyStatsTable.defaultSort"
									:excel="true"
									:fields="surveyStatsTable.headers"
									:header-selection-key="'survey-stats-headers'"
									:height="surveyStatsTable.height"
									:total-records="surveyStatsTable.total"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in surveyStatsTable.items.teachers"
										:key="key"
										:class="{ 'cursor-pointer': true }"
									>
										<td v-if="surveyStatsTable.selectedHeaders.includes('rbr')">
											{{ key + 1 }}
										</td>
										<td v-if="surveyStatsTable.selectedHeaders.includes('question')">
											{{
												$t('texts.teacherSurveyQuestion') +
												item.teacher_full_name +
												'? (ocjena 1-5)'
											}}
										</td>
										<td v-if="surveyStatsTable.selectedHeaders.includes('average_grade')">
											{{ item.average_teacher_rating.toFixed(2) }}
										</td>
									</tr>
									<tr>
										<td v-if="surveyStatsTable.selectedHeaders.includes('rbr')">
											{{ surveyStatsTable.total - 1 }}
										</td>
										<td v-if="surveyStatsTable.selectedHeaders.includes('question')">
											{{ $t('texts.surveyQuestion1') }}
										</td>
										<td v-if="surveyStatsTable.selectedHeaders.includes('average_grade')">
											{{ office_rating.toFixed(2) }}
										</td>
									</tr>
									<tr>
										<td v-if="surveyStatsTable.selectedHeaders.includes('rbr')">
											{{ surveyStatsTable.total }}
										</td>
										<td v-if="surveyStatsTable.selectedHeaders.includes('question')">
											{{ $t('texts.surveyQuestion2') }}
										</td>
										<td v-if="surveyStatsTable.selectedHeaders.includes('average_grade')">
											{{ course_rating.toFixed(2) }}
										</td>
									</tr>

									<tr>
										<td></td>
										<td>{{ $t('labels.sum') }}</td>
										<td>{{ averageTotal.toFixed(2) }}</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'SurveyStats',
	components: { TheTable },
	data: function () {
		return {
			surveyStatsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.rbr'),
						value: 'rbr',
						type: '',
						sortable: false,
						width: '50px',
						allowFilter: false,
					},
					{
						text: this.$t('fields.question'),
						value: 'question',
						type: '',
						sortable: false,
						allowFilter: false,
					},
					{
						text: this.$t('fields.averageGrade'),
						value: 'average_grade',
						type: '',
						sortable: false,
						allowFilter: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
			averageTotal: 0,
			initialLoad: false,
			office_rating: 0,
			course_rating: 0,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.surveyStatsTable.selectedHeaders = headers;
		},
		getTeachers() {
			var vm = this;
			this.$APICall(
				'get',
				'planned-course-teachers/' + this.$route.params.id,
				{},
				(data, success) => {
					if (success) {
						vm.plannedCourseTeachers = data;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let payload = {
				planned_course_id: this.$route.params.id,
				teachers: this.surveyStatsTable.items.teachers,
				course_rating: this.course_rating,
				office_rating: this.office_rating,
				average_total: this.averageTotal,
			};

			this.$APICall('post', 'excel/surveys-stats', payload, (data, success) => {
				window.open(data.link);
			});
		},
		reloadData(request) {
			this.surveyStatsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'surveys-stats/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.surveyStatsTable.items = data.items;
						vm.course_rating = data.course_rating;
						vm.office_rating = data.office_rating;
						vm.surveyStatsTable.total = data.total;
						vm.averageTotal = data.averageTotal;
						vm.initialLoad = true;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.surveyStatsTable.height = window.innerHeight - 390 + 'px';
		},
	},
	mounted() {
		let vm = this;
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadSurveyStats', () => {
			vm.reloadData(vm.surveyStatsTable.lastRequest);
		});

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
